import {
  VENUE_SELECTION_URL,
  EVENT_INFORMATION_URL,
  LIMITS_URL,
  COVERAGE_SUMMARY_URL,
  PAYMENT_URL,
} from "Constants/constants";
import { isVenuePageValid } from "Selectors/Venue";
import { isEventSelectionPageValid } from "Selectors/Event";
import { isUnderwritingQuestionsPageValid } from "Selectors/UnderwritingQuestions";
import { getIsLimitsPageValid } from "Selectors/Limits";
import { isEventInformationPageValid } from "Selectors/Event";

import Venue from "Components/Venue/Venue";
import Limits from "Components/Limits/Limits";
import QuoteSummaryFloater from "Components/QuoteSummaryFloater/QuoteSummaryFloater";
import EventSelection from "Components/EventSelection/EventSelection";
import EventInformation from "Components/EventInformation/EventInformation";
import InsuredPayment from "Components/InsuredPayment/InsuredPayment";
import CoverageSummary from "Components/CoverageSummary/CoverageSummary";

export const formStepsConfig = {
  // Key order matters here. The guard will check page validity of all previous steps relative to the currentPath.
  [VENUE_SELECTION_URL]: {
    component: () => (
      <>
        <Venue />
        <EventSelection />
      </>
    ),
    isPageValidSelector: (state) =>
      isVenuePageValid(state) && isEventSelectionPageValid(state),
    children: <QuoteSummaryFloater />,
  },
  [EVENT_INFORMATION_URL]: {
    component: () => (
      <>
        <EventInformation />
      </>
    ),
    isPageValidSelector: (state) =>
      isUnderwritingQuestionsPageValid(state) &&
      isEventInformationPageValid(state),
    children: <QuoteSummaryFloater />,
  },
  [LIMITS_URL]: {
    component: Limits,
    isPageValidSelector: getIsLimitsPageValid,
    children: <QuoteSummaryFloater />,
  },
  [COVERAGE_SUMMARY_URL]: {
    component: CoverageSummary,
    isPageValidSelector: null,
  },
  [PAYMENT_URL]: {
    component: InsuredPayment,
    isPageValidSelector: null,
    children: <QuoteSummaryFloater />,
  },
};
